import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import Login from '../components/Login';

const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      _id
      token
    }
  }
`;

const LOGIN_MUTATION_CONFIG = {
  props: ({mutate}) => ({
    login(variables) {
      return mutate({
        variables,
        update: (_, {data: {login}}) => {
          localStorage.setItem('@wkoWindowStore:authToken', login.token);
          location.reload();
        },
      });
    },
  }),
};
export default graphql(LOGIN_MUTATION, LOGIN_MUTATION_CONFIG)(Login);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js